import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { results } from '../data/content';
export function ResultsSection() {
  return <section aria-labelledby="resultados" className="border-y border-line bg-canvasAlt" data-id="element-219" data-mp="urxitod651av">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-220" data-mp="14oa7u8xrqqza">
        <Reveal data-id="element-221" data-mp="14m7ilr4fx1vm">
          <h2 id="resultados" className="font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-222" data-mp="70jlt542ohjk">
            Con este Mega Pack vas a poder:
          </h2>
          <p className="mt-1 text-sm font-bold uppercase tracking-[0.16em] text-blush" data-id="element-223" data-mp="gypmxki21jnd">
            Sin cambiar toda tu vida de golpe
          </p>
        </Reveal>

        <ul className="mx-auto mt-6 grid max-w-5xl gap-2 sm:grid-cols-2" data-id="element-224" data-mp="lqqzl7j4xcdx">
          {results.map((result, i) => <Reveal key={result} as="li" delay={i * 0.02} className="flex items-center justify-center gap-2.5 rounded-xl border border-line bg-surface px-4 py-3 text-sm font-medium text-ink" data-id="element-225" data-mp="3kdlorwql4j7o" data-mpi={i}>
              <CheckIcon size={15} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-226" data-mp="t9bra0cde0qh" />
              <span data-id="element-227" data-mp="jih4muv7oz4i">{result}</span>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}